import { RegisterPayload } from 'models/endpoints-payload'
import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_WT: string
declare const BIZ_BASE_URL_WT: string

export const registerUser = (payload: RegisterPayload): Promise<void> => {
  return promiseWrapper<null, RegisterPayload>(`${USER_BASE_URL_WT}/api/public/registration`, 'POST', payload, {
    withCredentials: true,
  })
}

export const registerUserBiz = (payload: RegisterPayload): Promise<void> => {
  return promiseWrapper<null, RegisterPayload>(`${BIZ_BASE_URL_WT}/api/public/registration`, 'POST', payload, {
    withCredentials: true,
  })
}
